import React from 'react';

import Layout from '../components/Layout';
import SEO from '../components/SEO';

const PortfolioPage = () => (
  <Layout>
    <SEO
      title="Portfolio"
      keywords={[
        `bai chan kheo`,
        `portfolio`,
        `developer`,
        `software`,
        `react`,
      ]}
    />
    <h1>Portfolio.</h1>
    <p>Portfolio goes here.</p>
  </Layout>
);

export default PortfolioPage;
